import { createFileRoute } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertCircle, Settings } from "lucide-react";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { SubscriptionStatusCard } from "@/components/subscriptions/subscription-status-card";
import { SubscriptionStatusCardSkeleton } from "@/components/subscriptions/subscription-status-card-skeleton";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import { isLocalInstallEdition } from "@/lib/edition/edition";
import { MoveToCloudCard } from "@/components/settings/move-to-cloud-card";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/subscription",
)({
  component: SubscriptionPage,
});

function SubscriptionPage() {
  const user = useQuery(api.system.users.queries.getCurrentUser);

  const subscriptionStatus = useQuery(
    api.companies.subscriptions.queries.getSubscriptionStatus,
    user?.internalControl?.companyId
      ? { companyId: user.internalControl.companyId }
      : "skip",
  );

  const onprem = isLocalInstallEdition();

  const content = (
    <div>

      <div className="flex flex-col gap-2">
        {subscriptionStatus === undefined ? (
          <SubscriptionStatusCardSkeleton className="max-w-md" />
        ) : subscriptionStatus !== null ? (
          <SubscriptionStatusCard
            className="max-w-md !gap-0 bg-gradient-to-tl from-zinc-200 via-zinc-100 to-zinc-200 dark:from-zinc-800 dark:via-zinc-800 dark:to-zinc-800  border border-border"
            status={subscriptionStatus}
            onUpgrade={() => console.log("Upgrade clicked")}
          />
        ) : (
          <Badge
            variant="outline"
            className="bg-gray-50 text-gray-700 border-gray-200"
          >
            <AlertCircle className="w-3 h-3 mr-1" />
            No disponible
          </Badge>
        )}
        {/* Escritorio free: llevar la empresa a la nube (solo administradores). */}
        <MoveToCloudCard className="max-w-md" />
      </div>
    </div>
  );

  // On-prem: los límites son informativos y no dependen del módulo de billing,
  // así que no exigimos el permiso subscription_plans.
  if (onprem) return content;

  return (
    <RouteGuardPermissions
      permissions={[
        { module: "subscription_plans", actions: ["read", "update"] },
      ]}
    >
      {content}
    </RouteGuardPermissions>
  );
}
